import { toast } from 'react-toastify';

import { callApi } from '../../../../apiCaller';
import { toastError } from '../../../../utils';
import { POPUP_TYPE } from '../../../../constants';

import {
     setIsWaiting,
     setIsLoading,
     setRemoveLoading,
     setShowRemovePopup,
     setShowPopup,
     setShowPopupDetail,
     setShowRelatedObjectWarningPopup,
} from '../../../../actions/general';
import { setAdminDataAddProduct } from '../GlobalStates/DataAddProduct/actions';

export const GET_SYSTEM_ADMIN_CE_PACK = 'getSystemAdminCePack';
export const ADD_SYSTEM_ADMIN_CE_PACK = 'addSystemAdminCePack';
export const ADD_SYSTEM_ADMIN_CE_PACKS = 'addSystemAdminCePacks';
export const UPDATE_SYSTEM_ADMIN_CE_PACK = 'updateSystemAdminCePack';
export const DELETE_SYSTEM_ADMIN_CE_PACK = 'deleteSystemAdminCePack';
export const API_SYSTEM_ADMIN_CE_PACK = 'ce-pack/:id';
export const API_SYSTEM_ADMIN_CE_PACKS = 'ce-pack';
export const API_SYSTEM_ADMIN_CE_PACK_DELETE_CHECKING = 'ce-pack/delete-checking/:id';

export const fetchSystemAdminCePack = (cePackId) => {
     return {
          type: GET_SYSTEM_ADMIN_CE_PACK,
          payload: cePackId,
     };
};

export const addSystemAdminCePack = (cePack) => {
     return {
          type: ADD_SYSTEM_ADMIN_CE_PACK,
          payload: cePack,
     };
};

export const addSystemAdminCePacks = (cePacks) => {
     return {
          type: ADD_SYSTEM_ADMIN_CE_PACKS,
          payload: cePacks,
     };
};

export const updateSystemAdminCePack = (cePack) => {
     return {
          type: UPDATE_SYSTEM_ADMIN_CE_PACK,
          payload: cePack,
     };
};

export const deleteSystemAdminCePack = (cePackId) => {
     return {
          type: DELETE_SYSTEM_ADMIN_CE_PACK,
          payload: cePackId,
     };
};

export const addCePackToDataAddProduct = (cePack) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct?.cePacks) {
          const newCePack = {
               id: cePack.id,
               name: cePack.name,
          };

          dataAddProduct.cePacks.push(newCePack);
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const updateCePackToDataAddProduct = (cePack) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;
     if (dataAddProduct !== null) {
          const newDataCePacks = dataAddProduct.cePacks.map((cePackItem) => {
               const newCePack = {
                    id: cePack.id,
                    name: cePack.name,
               };

               if (cePackItem.id === newCePack.id) {
                    return { ...cePackItem, ...newCePack };
               }

               return cePackItem;
          });

          dataAddProduct.cePacks = newDataCePacks;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const deleteCePackFromDataAddProduct = (id) => (dispatch, getState) => {
     const dataAddProduct = getState().admin.dataAddProduct;

     if (dataAddProduct !== null) {
          const newCePacks = dataAddProduct.cePacks.filter((item) => item.id !== id);
          dataAddProduct.cePacks = newCePacks;
          dispatch(setAdminDataAddProduct(dataAddProduct));
     }
};

export const fetchSystemAdminCePacks = () => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SYSTEM_ADMIN_CE_PACKS, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(addSystemAdminCePacks(response.data));
          })
          .catch((response) => {
               toastError(response);
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const addSystemAdminCePackRequest = (cePack) => (dispatch) => {
     dispatch(setIsWaiting(true));
     callApi(API_SYSTEM_ADMIN_CE_PACKS, 'POST', cePack)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newCEPack = response.data;

               dispatch(addSystemAdminCePack(newCEPack));
               dispatch(addCePackToDataAddProduct(newCEPack));
               dispatch(setShowPopup());

               toast.success('Created Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const updateSystemAdminCePackRequest = (cePackId, newCePack) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_CE_PACK.replace(':id', cePackId), 'PUT', newCePack)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               const newCEPack = response.data;
               dispatch(updateSystemAdminCePack(newCEPack));
               dispatch(updateCePackToDataAddProduct(newCEPack));

               dispatch(setShowPopupDetail(null));

               toast.success('Update Successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
          });
};

export const deleteSystemAdminCePackRequest = (cePackId) => (dispatch) => {
     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_CE_PACK.replace(':id', cePackId), 'DELETE')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    return;
               }
               dispatch(deleteSystemAdminCePack(cePackId));
               dispatch(deleteCePackFromDataAddProduct(cePackId));
          })
          .finally(() => {
               dispatch(setRemoveLoading(false));
               dispatch(setShowRemovePopup(null));
          });
};

export const checkCanDeleteCePackRequest = (cePackId) => (dispatch) => {
     callApi(API_SYSTEM_ADMIN_CE_PACK_DELETE_CHECKING.replace(':id', cePackId), 'GET').then((response) => {
          if (response.status === 200) {
               if (response.data.canDelete) {
                    dispatch(setShowRemovePopup(cePackId));
               }
          } else {
               if (response.data.isUsedForProducts) {
                    dispatch(setShowRemovePopup(null));
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
               } else {
                    toastError(response);
               }
          }
     });
};

export const checkUpdateCePackRequest = (nextDispatch) => (dispatch) => {
     const { isEditing, checkedValue, setFieldValue, setStatus, setStatusLoading, cePackId } = nextDispatch;

     //check status for delete only on edit page
     if (!isEditing && checkedValue) {
          setFieldValue('status', checkedValue);
          return;
     }

     setStatusLoading(true);

     return callApi(API_SYSTEM_ADMIN_CE_PACK_DELETE_CHECKING.replace(':id', cePackId), 'GET')
          .then((response) => {
               if (response.status === 200 && response.data.canDelete) {
                    setFieldValue('status', checkedValue);
                    return;
               }

               if (response.data.isUsedForProducts) {
                    dispatch(setShowRelatedObjectWarningPopup(POPUP_TYPE.WARNING_RELATED, response.data.message));
                    setStatus(!checkedValue);
                    setFieldValue('status', !checkedValue);
                    return;
               }

               toastError(response);
          })
          .finally(() => setStatusLoading(false));
};
